import catchAsync from "../../utils/catchAsync";
import http from "./http";

export const getServiceKeyApi = catchAsync(async (values) => {
  const data = await http.get(
    `/service/list?pageNumber=${values?.page}&dataPerPage=200&serviceType=keyService`
  );

  return data;
});

export const getServiceNonKeyApi = catchAsync(async (values) => {
  const data = await http.get(
    `/service/list?pageNumber=${values?.page}&dataPerPage=200&serviceType=nonKeyService`
  );

  return data;
});
